import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const appLayoutGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const authToken = authService.getAuthToken();
  const isLoggedIn = authService.isLoggedIn();

  if (authToken && isLoggedIn) {
    return true;
  }

  authService.clearSessionAndNavigateToAuth(router);
  return false;
};
